// TODO: allow exporting constants from api and share this value
// eslint-disable-next-line import/prefer-default-export
export const MATS_FOR_BORROW_REWARD_RATIO = 1
